import { schemes, zSchema, EOrderStatus } from "@zeal/common";

export const captureFinixTransactionsRequestSchema = zSchema.object({
  dateStr: zSchema.string(),
  companyID: schemes.uuid().optional(),
  orderID: schemes.uuid().optional(),
  invoiceID: schemes.uuid().optional(),
  testMode: zSchema.boolean().optional(),
});

export type TCaptureFinixTransactionsRequestSchema = zSchema.infer<
  typeof captureFinixTransactionsRequestSchema
>;

export const captureFinixTransactionsResponseSchema = zSchema.object({
  successfulCaptures: zSchema.array(schemes.uuid()),
  failedCaptures: zSchema.array(schemes.uuid()),
  orderUpdates: zSchema.array(
    zSchema.object({
      orderID: schemes.uuid(),
      companyID: schemes.uuid(),
      status: zSchema.nativeEnum(EOrderStatus),
      payment_receipt_link: zSchema.string().optional(),
    })
  ),
  invoiceUpdates: zSchema.array(
    zSchema.object({
      invoiceID: schemes.uuid(),
      companyID: schemes.uuid(),
      payment_receipt_link: zSchema.string().optional(),
    })
  ),
});

export type TCaptureFinixTransactionsResponseSchema = zSchema.infer<
  typeof captureFinixTransactionsResponseSchema
>;
